/**
 * Login Page JavaScript
 * Handles password visibility toggle, form validation, theme toggle, and form submission
 */

(function() {
    'use strict';

    // Wait for DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function() {
        initPasswordToggle();
        initFormValidation();
        initThemeToggle();
        initFormSubmission();
    });

    /**
     * Initialize password visibility toggle
     */
    function initPasswordToggle() {
        const toggleButton = document.getElementById('togglePassword');
        const passwordInput = document.getElementById('password');
        const toggleIcon = document.getElementById('toggleIcon');

        if (toggleButton && passwordInput && toggleIcon) {
            toggleButton.addEventListener('click', function() {
                // Toggle password visibility
                const type = passwordInput.type === 'password' ? 'text' : 'password';
                passwordInput.type = type;

                // Toggle icon
                if (type === 'text') {
                    toggleIcon.classList.remove('bi-eye');
                    toggleIcon.classList.add('bi-eye-slash');
                } else {
                    toggleIcon.classList.remove('bi-eye-slash');
                    toggleIcon.classList.add('bi-eye');
                }
            });
        }
    }

    /**
     * Initialize form validation
     */
    function initFormValidation() {
        const form = document.getElementById('loginForm');
        const emailInput = document.getElementById('email');
        const passwordInput = document.getElementById('password');

        if (form && emailInput && passwordInput) {
            // Email validation
            emailInput.addEventListener('blur', function() {
                validateEmail(emailInput);
            });

            // Password validation
            passwordInput.addEventListener('blur', function() {
                validatePassword(passwordInput);
            });

            // Form submission validation
            form.addEventListener('submit', function(event) {
                let isValid = true;

                if (!validateEmail(emailInput)) {
                    isValid = false;
                }

                if (!validatePassword(passwordInput)) {
                    isValid = false;
                }

                if (!isValid) {
                    event.preventDefault();
                }
            });
        }
    }

    /**
     * Validate email field
     * @param {HTMLInputElement} input - Email input element
     * @returns {boolean} - True if valid, false otherwise
     */
    function validateEmail(input) {
        const email = input.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email) {
            setFieldError(input, 'Email is required');
            return false;
        }

        if (!emailRegex.test(email)) {
            setFieldError(input, 'Please enter a valid email address');
            return false;
        }

        clearFieldError(input);
        return true;
    }

    /**
     * Validate password field
     * @param {HTMLInputElement} input - Password input element
     * @returns {boolean} - True if valid, false otherwise
     */
    function validatePassword(input) {
        const password = input.value;

        if (!password) {
            setFieldError(input, 'Password is required');
            return false;
        }

        if (password.length < 6) {
            setFieldError(input, 'Password must be at least 6 characters');
            return false;
        }

        clearFieldError(input);
        return true;
    }

    /**
     * Set field error state and message
     * @param {HTMLInputElement} input - Input element
     * @param {string} message - Error message
     */
    function setFieldError(input, message) {
        input.classList.add('is-invalid');
        input.classList.remove('is-valid');

        // Remove existing error message if present
        const existingError = input.parentElement.querySelector('.invalid-feedback');
        if (existingError) {
            existingError.remove();
        }

        // Add error message
        const errorDiv = document.createElement('div');
        errorDiv.className = 'invalid-feedback d-block';
        errorDiv.textContent = message;
        input.parentElement.appendChild(errorDiv);
    }

    /**
     * Clear field error state
     * @param {HTMLInputElement} input - Input element
     */
    function clearFieldError(input) {
        input.classList.remove('is-invalid');
        input.classList.add('is-valid');

        // Remove error message
        const errorDiv = input.parentElement.querySelector('.invalid-feedback');
        if (errorDiv) {
            errorDiv.remove();
        }
    }

    /**
     * Initialize theme toggle
     */
    function initThemeToggle() {
        const themeToggle = document.getElementById('themeToggle');
        const themeIcon = document.getElementById('themeIcon');

        if (themeToggle && themeIcon) {
            // Load saved theme or default to light
            const savedTheme = localStorage.getItem('theme') || 'light';
            setTheme(savedTheme, themeIcon);

            // Toggle theme on button click
            themeToggle.addEventListener('click', function() {
                const currentTheme = document.documentElement.getAttribute('data-theme') || 'light';
                const newTheme = currentTheme === 'light' ? 'dark' : 'light';
                setTheme(newTheme, themeIcon);
                localStorage.setItem('theme', newTheme);
            });
        }
    }

    /**
     * Set theme and update icon
     * @param {string} theme - Theme name ('light' or 'dark')
     * @param {HTMLElement} icon - Theme icon element
     */
    function setTheme(theme, icon) {
        if (theme === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
            icon.classList.remove('bi-moon-fill');
            icon.classList.add('bi-sun-fill');
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
            icon.classList.remove('bi-sun-fill');
            icon.classList.add('bi-moon-fill');
        }
    }

    /**
     * Initialize form submission handling
     */
    function initFormSubmission() {
        const form = document.getElementById('loginForm');
        const submitButton = document.getElementById('btnLogin');

        if (form && submitButton) {
            form.addEventListener('submit', function(e) {
                // If validation already prevented submission, don't proceed
                if (e.defaultPrevented) return;

                // Show spinner
                submitButton.disabled = true;
                const btnText = submitButton.querySelector('.btn-text');
                const btnSpinner = submitButton.querySelector('.btn-spinner');
                if (btnText && btnSpinner) {
                    btnText.textContent = 'Signing In...';
                    btnSpinner.classList.remove('d-none');
                }

                // reCAPTCHA v3: get token then submit
                if (window.recaptchaSiteKey) {
                    e.preventDefault();
                    grecaptcha.ready(function () {
                        grecaptcha.execute(window.recaptchaSiteKey, { action: 'login' }).then(function (token) {
                            var input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = 'g-recaptcha-response';
                            input.value = token;
                            form.appendChild(input);
                            form.submit();
                        });
                    });
                }
            });
        }
    }

    /**
     * Auto-dismiss alerts after 5 seconds
     */
    function initAlertAutoDismiss() {
        const alerts = document.querySelectorAll('.alert-dismissible');
        
        alerts.forEach(function(alert) {
            setTimeout(function() {
                const bsAlert = new bootstrap.Alert(alert);
                bsAlert.close();
            }, 5000);
        });
    }

    // Initialize alert auto-dismiss
    initAlertAutoDismiss();

})();
